(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('swym-wishlist-icons')) {
    class SwymWishlistIcons extends HTMLElement {
      #observer;

      connectedCallback() {
        this.#syncButtons();

        this.#observer = new MutationObserver(() => this.#syncButtons());
        this.#observer.observe(document.body, {
          attributes: true,
          attributeFilter: ['aria-label', 'aria-pressed', 'class', 'd', 'fill', 'stroke', 'viewBox', 'width', 'height'],
          childList: true,
          subtree: true,
        });
      }

      disconnectedCallback() {
        this.#observer?.disconnect();
      }

      #syncButtons() {
        const buttons = document.querySelectorAll('#swym-atw-pdp-button, .swym-wishlist-collections-v2');

        for (const button of buttons) {
          this.#syncButton(button);
        }
      }

      #syncButton(button) {
        const isChecked =
          button.matches('[aria-pressed="true"], .atw-button-added, .swym-added') ||
          button.getAttribute('aria-label')?.toLowerCase().includes('remove');
        const state = isChecked ? 'checked' : 'unchecked';
        const currentIcon = button.querySelector('svg');
        const template = this.querySelector(`template[data-state="${state}"]`);
        const templateIcon = template?.content.firstElementChild;
        const currentPath = currentIcon?.querySelector('path');
        const templatePath = templateIcon?.querySelector('path');
        const iconMatches =
          currentIcon?.dataset.swymIconState === state &&
          currentIcon.getAttribute('viewBox') === templateIcon?.getAttribute('viewBox') &&
          currentPath?.getAttribute('d') === templatePath?.getAttribute('d') &&
          currentPath?.getAttribute('fill') === templatePath?.getAttribute('fill') &&
          currentPath?.getAttribute('stroke') === templatePath?.getAttribute('stroke');

        if (!currentIcon || iconMatches) return;

        const icon = templateIcon?.cloneNode(true);

        if (!icon) return;

        for (const attribute of ['id', 'class', 'aria-hidden', 'focusable']) {
          if (currentIcon.hasAttribute(attribute)) {
            icon.setAttribute(attribute, currentIcon.getAttribute(attribute));
          }
        }

        icon.dataset.swymIconState = state;
        currentIcon.replaceWith(icon);
      }
    }

    customElements.define('swym-wishlist-icons', SwymWishlistIcons);
  }

  } catch(e) { console.error(e); }
})();
})();
